export const PAGE_ALLERGY = 'PAGE_ALLERGY';
